module.exports = __webpack_public_path__ + "py.dd93162b07bdbebefbae.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/py.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/py.svg
// module chunks = styles